import { OnlineOrder } from './online-order';

export class Order {
    token: string;
    onlineOrder: OnlineOrder;
    isRecurrent?: boolean;
    periodSubscription?:any;
}